import howItWorksImg from "../assets/how-it-works.png";

const HowItWorks = () => {
    return (
        <section className="how-it-works">
            <m>Your Path to Success</m>
            <h1>How It Works - For Startups</h1>

            <div className="content-wrapper">
                <img src={howItWorksImg} alt="How It Works" className="main-image" />
                <button
                    className="apply-button"
                    onClick={() => window.open("https://forms.gle/2ewkTW56QUAMHY1g9", "_blank")}
                >
                    APPLY NOW
                </button>
                {/* <div className="text-overlay">
                    <div className="text-block apply">
                        <h2>1. Apply</h2>
                        <p>Fill out the form</p>
                    </div>
                    <div className="text-block match">
                        <h2>2. Get Matched</h2>
                        <p>Find co-founders & advisors</p>
                    </div>
                    <div className="text-block scale">
                        <h2>3. Build & Scale</h2>
                        <p>Leverage AI, funding, and mentorship</p>
                    </div>
                </div> */}
            </div>
        </section>
    );
};

export default HowItWorks;